
const emailSettingsPageStore = {
    state: () => ({
        createEmailSettingPanelIsOpen: false,
        updateEmailSettingPanelIsOpen: false,
    }),
    actions: {
        openCreateEmailSettingPanel: ({commit}) => {
            commit('setCreateEmailSettingPanelIsOpen', true)
        },
        closeCreateEmailSettingPanel: ({commit}) => {
            commit('setCreateEmailSettingPanelIsOpen', false)
        },

        openUpdateEmailSettingPanel: ({commit}) => {
            commit('setUpdateEmailSettingPanelIsOpen', true)
        },
        closeUpdateEmailSettingPanel: ({commit}) => {
            commit('setUpdateEmailSettingPanelIsOpen', false)
        },
    },
    mutations: {
        setCreateEmailSettingPanelIsOpen: (state, isOpen) => {
            state.createEmailSettingPanelIsOpen = isOpen
        },
        setUpdateEmailSettingPanelIsOpen: (state, isOpen) => {
            state.updateEmailSettingPanelIsOpen = isOpen
        },

    },
    getters: {
        getCreateEmailSettingPanelIsOpen: state => {
            return state.createEmailSettingPanelIsOpen
        },
        getUpdateEmailSettingPanelIsOpen: state => {
            return state.updateEmailSettingPanelIsOpen
        }
    }
}

export default emailSettingsPageStore
